import React from "react";
import ContactForm from "../components/ContactForm";
import heroImg from "../assets/contact-us/contact-us-hero-bg.jpg";
import FaqSection from "../components/FaqSection";
import { FaPhone } from "react-icons/fa";

export default function ContactUsPage() {
  return (
    <>
      <section className="relative w-full h-[60vh] md:h-[80vh] flex items-end text-white overflow-hidden">
        {/* Background image */}
        <img
          src={heroImg}
          alt="Hero background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* FULL OVERLAY tint instead of gradient */}
        <div
          className="absolute inset-0 z-10"
          style={{
            background:
              "linear-gradient(rgba(31, 41, 84, 0.5) 10%, rgba(239, 81, 75, 0.6) 77%)",
          }}
        />

        {/* Text content */}
        {/* <div className="relative z-20 p-6 md:p-20 mb-20">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4">
            Do you have any questions?
          </h1>
          <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
            Get in touch.
          </p>
        </div> */}

        <div className="relative z-20 p-6 md:p-20 mb-20">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4">
            Do you have any questions?
          </h1>
          <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
            Get in touch.
          </p>

          {/* 👇 Add this contact info block */}
          {/* <div className="mt-6 text-lg md:text-xl flex flex-row gap-4">
            <p className="font-bold">Contact us directly:</p>
            <FaPhone className="w-5 h-5 text-brandAccent" />

            <a
              href="tel:+447943097999"
              className="text-white font-bold hover:underline"
            >
              +447943097999
            </a>
          </div> */}
        </div>
      </section>

      <section className="relative -mt-20 bg-[#1c2553] text-white px-5 py-10 rounded-t-3xl md:rounded-t-[50px] z-30">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-brandAccent font-semibold mb-6 text-center">
          Submit a request
        </h1>

        <div className="mt-6 flex flex-col md:flex-row items-center gap-4 text-lg md:text-xl text-center justify-center mb-10">
          <p className="text-lg">Prefer talking directly?</p>
          <div className="flex gap-1">
            <FaPhone className="w-5 h-5 text-brandAccent" />
            <a
              href="tel:+443337723333"
              className="text-brandAccent font-semibold hover:underline"
            >
              +44 333 772 3333
            </a>
          </div>
        </div>

        <ContactForm />
      </section>

      <FaqSection />
    </>
  );
}
